import { PERFIL_HIERARQUIA, PERFIL_NOMES, type Perfil } from '@/constants/perfis/Perfil';

// Papéis que o Keycloak põe em todo token e não são perfil (ex.: default-roles-<realm>).
const PAPEIS_TECNICOS = /^(default-roles-.+|offline_access|uma_authorization)$/;

const PREFIXO_SNAPSHOT = 'agnes:ultimo-acesso:';

export interface SnapshotAcesso {
  perfil: string;
}

export interface AlteracaoPerfil {
  alterado: boolean;
  perfilDe: string;
  perfilPara: string;
}

export function perfilPrincipal(papeis: string[] = []): string {
  const perfil = PERFIL_HIERARQUIA.find((p) => papeis.includes(p));
  if (perfil) return perfil;
  return papeis.find((p) => !PAPEIS_TECNICOS.test(p)) ?? '';
}

export function nomePerfil(perfil: string): string {
  return PERFIL_NOMES[perfil as Perfil] ?? perfil;
}

export function detectarAlteracao(
  anterior: SnapshotAcesso | null,
  perfilAtual: string,
): AlteracaoPerfil {
  const perfilDe = anterior?.perfil ?? '';
  return {
    alterado: Boolean(perfilDe && perfilAtual && perfilDe !== perfilAtual),
    perfilDe: nomePerfil(perfilDe),
    perfilPara: nomePerfil(perfilAtual),
  };
}

// Fica fora do authStorage: precisa sobreviver ao logout e à sessão sem "manter conectado".
function chave(tenant: string, usuarioId: string) {
  return `${PREFIXO_SNAPSHOT}${tenant}:${usuarioId}`;
}

export function lerSnapshot(tenant: string, usuarioId: string): SnapshotAcesso | null {
  try {
    const raw = localStorage.getItem(chave(tenant, usuarioId));
    return raw ? (JSON.parse(raw) as SnapshotAcesso) : null;
  } catch {
    return null;
  }
}

export function gravarSnapshot(tenant: string, usuarioId: string, snapshot: SnapshotAcesso) {
  try {
    localStorage.setItem(chave(tenant, usuarioId), JSON.stringify(snapshot));
  } catch {
    // localStorage indisponível (modo privado/bloqueado): o aviso só deixa de aparecer.
  }
}

/** Compara com o último acesso e regrava o snapshot, para o aviso sair uma vez só. */
export function verificarAlteracaoPerfil(
  tenant: string,
  usuarioId: string,
  papeis: string[],
): AlteracaoPerfil {
  const perfilAtual = perfilPrincipal(papeis);
  const resultado = detectarAlteracao(lerSnapshot(tenant, usuarioId), perfilAtual);
  if (perfilAtual) gravarSnapshot(tenant, usuarioId, { perfil: perfilAtual });
  return resultado;
}
